import {
  ComboBox,
  IColumn,
  IComboBox,
  IComboBoxOption,
  ICommandBarItemProps,
  Panel,
  PanelType,
  Persona,
  PersonaSize,
  Stack,
  TooltipHost,
  PrimaryButton,
  DefaultButton,
  TextField
} from "@fluentui/react";
import { selection } from "d3";
import { useEffect, useState } from "react";
import { TableBase } from "../../../components/Table/TableBase";
import {
  IBase,
  IException,
  IItemComboBaseDTO,
  ISearch,
} from "../../../interfaces/base/IBase";
import { IDataCollection, IPagination } from "../../../interfaces/base/ITable";
import {
  IFilterAsignacionAcciones,
  IProgramacionPersona,
} from "../../../interfaces/IProgramacion";
import ProgramacionBusService from "../../../services/programacionBusService";
import {
  baseImageUrl,
  IndexNone,
  ItemNoneSelect,
  splitExceptionDetail,
  stackTokens,
  _initialFilter,
  _initialPagination,
} from "../../../utils/Helper/helper";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import { _initialDataCollection } from "../../../utils/Helper/tableHelper";
import ThemeBase from "../../../utils/Theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import React from "react";
import ConfiguracionService from "../../../services/configuracionService";
import OrganigramaService from "../../../services/organigramaService";
import PersonaService from "../../../services/PersonaService";
import { Ifilter } from "../../../interfaces/IFilter";
import { IFilterUbicacion } from "../../../interfaces/filter/IFilterUbicacion";
import { UbicacionHelper } from "../../../utils/Helper/ubicacionHelper";
import UbicacionService from "../../../services/ubicacionesServices";
import ProgramacionService from "../../../services/ProgramacionService";

export const ListarAsignadoBus = ({
  programacionId = "",
  estaAbordado = false,
}) => {
  const [hidden, setHidden] = useState(false);

  const [destino, setDestino] = useState<IItemComboBaseDTO[]>([]);

  const [isOpenFiltro, { setTrue: openFiltro, setFalse: dismissFiltro }] =
    useBoolean(false);

  /* Filter */
  const [filter, setFilter] = useState<IFilterAsignacionAcciones>({
    ..._initialFilter(),
    programacionId: programacionId,
    estaAbordado: estaAbordado,
  });
  const [filtroTabla, setFiltroTabla] = useState(false);
  const [filterDestino, setFilterDestino] = useState<ISearch>(_initialFilter);

  /* Ref */
  const refDestino = React.useRef<IComboBox>(null);

  /* Panel Filter */
  const [isOpenFilter, { setTrue: openFilter, setFalse: dismissFilter }] =
    useBoolean(false);

  /* Data & Colum */
  const [data, setData] = useState<IDataCollection<IProgramacionPersona>>(
    _initialDataCollection
  );
  const [column, setColumn] = useState<IColumn[]>([]);

  /* Pagination */
  const [currentPage, setCurrentPage] = useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
  const [total, setTotal] = useState(_initialPagination().total);

  const [pager, setPager] = useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => dataByPager(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  const refCampamento = React.useRef<IComboBox>(null);
  const refEmpresa = React.useRef<IComboBox>(null);
  const refGerencia = React.useRef<IComboBox>(null);
  const refLugarMovilizacion = React.useRef<IComboBox>(null);

  const [campamento, setCampamento] = useState<IItemComboBaseDTO[]>([]);
  const [empresa, setEmpresa] = useState<IItemComboBaseDTO[]>([]);
  const [gerencia, setGerencia] = useState<IItemComboBaseDTO[]>([]);
  const [lugarMovilizacion, setLugarMovilizacion] = useState<IItemComboBaseDTO[]>([]);

  const _openCampamento = React.useCallback(
    () => refCampamento.current?.focus(true),
    []
  );
  const _openEmpresa = React.useCallback(
    () => refEmpresa.current?.focus(true),
    []
  );
  const _openGerencia = React.useCallback(
    () => refGerencia.current?.focus(true),
    []
  );
  const _openLugarMovilizacion = React.useCallback(
    () => refLugarMovilizacion.current?.focus(true),
    []
  );


  const [filterCampamento, setFilterCampamento] = useState<ISearch>(_initialFilter);
  const [filterEmpresa, setFilterEmpresa] = useState<ISearch>(_initialFilter);
  const [filterGerencia, setFilterGerencia] = useState<ISearch>(_initialFilter);
  const [filterLugarMovilizacion, setFilterLugarMovilizacion] = useState<ISearch>(_initialFilter);
  const [filterBusVigente, setFilterBusVigente] = useState<Ifilter>(_initialFilter);

  const [selBusForm, setSelBusForm] = useState<IComboBoxOption>(null!);


  const _onInputDestino = (e: React.KeyboardEvent<IComboBox>) => {
    _openCampamento();
    let { value } = e?.target as HTMLInputElement;

    if (filter.campamentoId != null) {
      setFilter({
        ...filter,
        campamentoId: null,
      });
    }

    setFilterCampamento({
      ...filterCampamento,
      search: value,
    });
  };

  const _onInputEmpresa = (e: React.KeyboardEvent<IComboBox>) => {
    _openEmpresa();
    let { value } = e?.target as HTMLInputElement;

    if (filter.empresaId != null) {
      setFilter({
        ...filter,
        empresaId: null,
      });
    }

    setFilterEmpresa({
      ...filterEmpresa,
      search: value,
    });
  };

  const _onInputGerencia = (e: React.KeyboardEvent<IComboBox>) => {
    _openGerencia();
    let { value } = e?.target as HTMLInputElement;

    if (filter.gerenciaId != null) {
      setFilter({
        ...filter,
        gerenciaId: null,
      });
    }

    setFilterGerencia({
      ...filterGerencia,
      search: value,
    });
  };

  const _onInputLugarMovilizacion = (e: React.KeyboardEvent<IComboBox>) => {
    _openLugarMovilizacion();
    let { value } = e?.target as HTMLInputElement;

    if (filter.lugarMovilizacionId != null) {
      setFilter({
        ...filter,
        lugarMovilizacionId: null,
      });
    }

    setFilterLugarMovilizacion({
      ...filterLugarMovilizacion,
      search: value,
    });
  };

  const dataCampamento = () => {
    setCampamento([]);

    const filterDestino: IFilterUbicacion = {
      tipo: UbicacionHelper.TIPO_DESTINO,
      search: filterCampamento.search,
    };

    UbicacionService.ubicacionPorFiltro(filterDestino)
      .then((res) => {
        let t: IItemComboBaseDTO[] = res.data;
        t.unshift(ItemNoneSelect());
        setCampamento(t);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const dataEmpresa = () => {
    setEmpresa([]);
    ConfiguracionService.allEmpresa(filterEmpresa)
      .then((res) => {
        if (res.status == 200) {
          let t: IItemComboBaseDTO[] = res.data;
          t.unshift(ItemNoneSelect());

          setEmpresa(t);
        }
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
      });
  };

  const dataGerencia = () => {
    setGerencia([]);
    OrganigramaService.organigramaByTipo("01", filterGerencia)
      .then((res) => {
        if (res.status == 200) {
          let t: IItemComboBaseDTO[] = res.data;
          t.unshift(ItemNoneSelect());

          setGerencia(t);
        }
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
      });
  };

  const dataLugarMovilizacion = () => {
    ProgramacionService.allLugarMovilizacion1(filterLugarMovilizacion)
      .then((res) => {
        setLugarMovilizacion(res.data);
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
      });
  };

  const _clearSearch = (type: string) => {
    switch (type) {
      case "bus":
        setSelBusForm(null!);

        setFilterBusVigente({
          ...filterBusVigente,
          search: "",
        });
        break;
      case "campamento":
        setFilterCampamento({
          ...filterCampamento,
          search: "",
        });
        break;
      case "empresa":
        setFilterEmpresa({
          ...filterEmpresa,
          search: "",
        });
        break;
      case "gerencia":
        setFilterGerencia({
          ...filterGerencia,
          search: "",
        });
        break;
      case "LugarMovilizacion":
        setFilterLugarMovilizacion({
          ...filterLugarMovilizacion,
          search: "",
        });
        break;
      default:
        break;
    }
  };

  const _onChangeCombo = (
    type: string,
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        let k: string | null = null;

        let isNone = option.key == IndexNone;

        if (isNone) {
          _clearSearch(type);
        }

        switch (type) {
          case "bus":
            if (!isNone) {
              setSelBusForm(option);
            }

            break;
          case "campamento":
            if (!isNone) {
              k = String(option.key);
            }

            setFilter({
              ...filter,
              campamentoId: k,
            });
            break;
          case "empresa":
            if (!isNone) {
              k = String(option.key);
            }

            setFilter({
              ...filter,
              empresaId: k,
            });
            break;
          case "gerencia":
            if (!isNone) {
              k = String(option.key);
            }
            setFilter({
              ...filter,
              gerenciaId: k,
            });
            break;
          case "LugarMovilizacion":
            if (!isNone) {
              k = String(option.key);
            }
            setFilter({
              ...filter,
              lugarMovilizacionId: k,
            });
            break;
          default:
            break;
        }
      }
    }
  };

  const _onBlurCombo = (type: string) => {
    switch (type) {
      case "bus":
        if (selBusForm == undefined && selBusForm != null) {
        }
        break;
      case "campamento":
        if (
          (filter.campamentoId == "" ||
            filter.campamentoId == undefined) &&
          filter.campamentoId != null
        ) {
          setFilter({
            ...filter,
            campamentoId: null,
          });
        }
        break;
      case "empresa":
        if (
          (filter.empresaId == "" || filter.empresaId == undefined)
        ) {
          setFilter({
            ...filter,
            empresaId: null,
          });
        }
        break;
      case "gerencia":
        if (
          (filter.gerenciaId == "" || filter.gerenciaId == undefined) &&
          filter.gerenciaId != null
        ) {
          setFilter({
            ...filter,
            gerenciaId: null,
          });
        }
        break;
      case "LugarMovilizacion":
        if (
          (filter.lugarMovilizacionId == "" ||
            filter.lugarMovilizacionId == undefined) &&
          filter.lugarMovilizacionId != null
        ) {
          setFilter({
            ...filter,
            lugarMovilizacionId: null,
          });
        }
        break;
      default:
        break;
    }
  };

  /* Hook */
  useEffect(() => {
    if (programacionId != "") {
      reloadInitial();
    }
  }, []);

  useEffect(() => {
    if (filterDestino.search != null) {
      dataDestino();
    }
  }, [filterDestino]);

  useEffect(() => {
    if (filterEmpresa.search != null) {
      dataEmpresa();
    }
  }, [filterEmpresa]);

  useEffect(() => {
    if (filterGerencia.search != null) {
      dataGerencia();
    }
  }, [filterGerencia]);

  /* Hook Pagination */
  useEffect(() => {
    setPager({
      ...pager,
      currentPage: currentPage,
    });

    if (filter) {
      setFilter({
        ...filter,
        skip: (currentPage - 1) * pageSize,
        take: pageSize,
      });
    }
  }, [currentPage]);

  useEffect(() => {
    setPager({
      ...pager,
      onPageChange: (page) => dataByPager(page),
      onSizeChange: (pageSize) => setPageSize(pageSize),
      total: total,
    });
  }, [total]);

  /* Api */
  const dataAsignado = (param = filter) => {
    if (programacionId != "") {
      setData(_initialDataCollection);
      ProgramacionBusService.allAsignadoBus(param)
        .then((res) => {
          if (res.status == 200) {
            setData(res.data);
            setHidden(true);
            setTotal(res.data.total);
          }
        })
        .catch((e: IException) => {
          alert(splitExceptionDetail(e));
          setHidden(true);
        });
    }
  };

  const dataDestino = () => {
    PersonaService.getComboCampamento1(filterDestino)
      .then((res) => {
        let d: IBase[] = res.data.data;

        let t: IItemComboBaseDTO[] = d.map((x) => {
          return {
            key: x.id,
            text: x.nombre,
          };
        });

        t.unshift(ItemNoneSelect());

        setDestino(t);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  /* Function */
  const reloadInitial = (param = filter) => {
    setHidden(false);
    setTitleColumn();
    dataAsignado(param);
  };

  useEffect(() => {
    if (isOpenFiltro) {
      dataCampamento();
      dataEmpresa();
      dataGerencia();
      dataLugarMovilizacion();
    }
  }, [isOpenFiltro])

  const _leftBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_BACK,
        onClick: () => {
          alert("back");
        },
      },
      {
        ...IconHelper.ICON_RELOAD,
        onClick: () => reloadInitial(),
      },
    ];

    return _items;
  };

  const _rightBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_FILTER,
        text: "Filtrar",
        onClick: () => {
          openFiltro();
        },
      },
    ];

    return _items;
  };

  const setTitleColumn = () => {
    let col: IColumn[] = [
      {
        key: "column1",
        name: "Foto",
        ariaLabel:
          "Column operations for File type, Press to sort on File type",
        iconName: "-",
        isIconOnly: true,
        fieldName: "foto",
        minWidth: 30,
        maxWidth: 30,
        onRender: (item: IProgramacionPersona) => (
          <TooltipHost content={`Foto`}>
            <Persona
              text=""
              size={PersonaSize.size24}
              imageUrl={baseImageUrl}
            />
          </TooltipHost>
        ),
      },
      {
        key: "column2",
        name: "Nombre",
        fieldName: "nombres",
        minWidth: 170,
        maxWidth: 170,
        isRowHeader: true,
        isResizable: true,
        data: "string",
        isPadded: true,
        onRender: (item: IProgramacionPersona) => {
          return <span style={{ fontSize: "90%" }}>{item.nombres}</span>;
        },
      },
      {
        key: "column3",
        name: "Identificación",
        fieldName: "nroDOI",
        minWidth: 80,
        maxWidth: 90,
        isResizable: true,
        data: "number",
        isPadded: true,
        onRender: (item: IProgramacionPersona) => {
          return (
            <span
              style={{ fontSize: "95%" }}
            >{`${item.tipoDocumento} ${item.nroDOI}`}</span>
          );
        },
      },
      // {
      //     key: 'column4',
      //     name: 'Email',
      //     fieldName: 'email',
      //     minWidth: 180,
      //     maxWidth: 180,
      //     isResizable: true,
      //     isCollapsible: true,
      //     data: 'string',
      //     isPadded: true,
      // },
      // {
      //     key: 'column5',
      //     name: 'Celular',
      //     fieldName: 'celular',
      //     minWidth: 70,
      //     maxWidth: 90,
      //     isResizable: true,
      //     isCollapsible: true,
      //     data: 'string',
      //     isPadded: true,
      // },
      {
        key: "column6",
        name: "Gerencia",
        fieldName: "gerencia",
        minWidth: 150,
        maxWidth: 150,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column7",
        name: "Lugar Mov.",
        fieldName: "lugarMovilizacionV2",
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column8",
        name: "Embarque",
        fieldName: "embarque",
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column9",
        name: "Destino",
        fieldName: "destino",
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column10",
        name: "Empresa Transportista",
        fieldName: "empresaTransporte",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "string",
        onRender: (item) => {
          return (
            <span
              style={{ fontSize: "95%" }}
            >{`${item.empresaTransporte ? item.empresaTransporte : "No asignado"}`}</span>
          );
        },
      },
      {
        key: "column11",
        name: "Placa",
        fieldName: "placa",
        minWidth: 80,
        maxWidth: 80,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column12",
        name: "Código Interno",
        fieldName: "codigoInterno",
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column13",
        name: "Empresa Persona",
        fieldName: "empresaPersona",
        minWidth: 250,
        maxWidth: 250,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      // {
      //     key: "column13",
      //     name: "Fecha Ingreso",
      //     fieldName: "fechaIngreso",
      //     minWidth: 100,
      //     maxWidth: 100,
      //     isResizable: true,
      //     isCollapsible: true,
      //     data: "number",
      // },
      {
        key: "column14",
        name: "Nivel",
        fieldName: "nivelActual",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
      {
        key: "column15",
        name: "Estado",
        fieldName: "estadoActual",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
    ];

    setColumn(col);
  };

  /* Event Tab */
  const dataByPager = (page) => {
    if (true) {
      setTotal(0);

      setPager({
        ...pager,
        currentPage: page,
      });

      let f: IFilterAsignacionAcciones = {
        ...filter,
        skip: (page - 1) * pageSize,
        take: pageSize,
      };

      setFilter(f);
      setCurrentPage(page);

      reloadInitial(f);
    }
  };

  /* Event Filter */
  const _onUpCombo = (type: string, ev?: React.KeyboardEvent<IComboBox>) => {
    let { value } = ev?.target as HTMLInputElement;

    switch (type) {
      case "destino":
        _openCampamento();

        if (filter.campamentoId != null) {
          setFilter({
            ...filter,
            campamentoId: null,
          });

          reloadInitial();
        }

        setFilterDestino({
          ...filterDestino,
          search: value,
        });
        break;
      case "empresa":
        _openEmpresa();

        if (filter.empresaId != null) {
          setFilter({
            ...filter,
            empresaId: null,
          });

          reloadInitial();
        }

        setFilterEmpresa({
          ...filterEmpresa,
          search: value,
        });
        break;
      case "gerencia":
        _openGerencia();

        if (filter.gerenciaId != null) {
          setFilter({
            ...filter,
            gerenciaId: null,
          });

          reloadInitial();
        }

        setFilterGerencia({
          ...filterGerencia,
          search: value,
        });
        break;
      default:
        break;
    }
  };

  const _onChangeInput = (type: string, event, newValue) => {
    const value = event.target.value;

    switch (type) {
      case "nroDOI":
        if (newValue.length > 0) {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nroDOI: value
          });
        } else {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nroDOI: null
          });
        }
        break;
      case "nombre":
        if (newValue.length > 0) {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nombre: value
          });
        } else {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nombre: null
          });
        }
        break;
    }
  };

  useEffect(() => {
    if (filtroTabla) {
      setHidden(false)
      dataAsignado();
      setFiltroTabla(false);
    }
  }, [filtroTabla]);


  const handleFiltrar = () => {
    setFiltroTabla(true);
  };

  const _onRenderFooterFiltro = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={handleFiltrar}
          styles={ThemeBase.panelButtonStyle}
        >
          Filtrar
        </PrimaryButton>
        <DefaultButton onClick={dismissFiltro}>Cancelar</DefaultButton>
      </div>
    ),
    [dismissFiltro]
  );

  return (
    <>
      <TableBase
        leftBar={_leftBar()}
        rigthBar={_rightBar()}
        column={column}
        data={data.items}
        style={ThemeBase.notPaddingTableBase}
        pagination={pager}
        isLoading={!hidden}
        selection={selection}
      ></TableBase>

      <Panel
        isOpen={isOpenFiltro}
        onDismiss={dismissFiltro}
        headerText={`Filtrado`}
        closeButtonAriaLabel="Close"
        onRenderFooterContent={_onRenderFooterFiltro}
        isFooterAtBottom={true}
      >
        <>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <br />
              <div
                className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
                style={ThemeBase.notPaddingSide}
              >
                <TextField
                  label="Documento de Identidad"
                  name="nroDOI"
                  type="text"
                  placeholder="Ingrese el dni"
                  onChange={(e, o) => _onChangeInput("nroDOI", e, o)}
                  defaultValue={filter.nroDOI ?? ""}
                  minLength={8}
                  maxLength={8}
                />
                <br />
                <TextField
                  label="Nombre"
                  name="nombre"
                  type="text"
                  placeholder="Ingrese el nombre"
                  onChange={(e, o) => _onChangeInput("nombre", e, o)}
                  defaultValue={filter.nombre ?? ""}
                />
                <br />
                <ComboBox
                  label="Destino:"
                  componentRef={refCampamento}
                  placeholder="Seleccione Destino"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={campamento}
                  onInput={_onInputDestino}
                  selectedKey={filter.campamentoId}
                  onChange={(e, o) => _onChangeCombo("campamento", e, o)}
                  onBlur={() => _onBlurCombo("campamento")}
                />
                <br />
                <ComboBox
                  label="Empresa Persona:"
                  componentRef={refEmpresa}
                  placeholder="Seleccione Empresa Persona"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={empresa}
                  onInput={_onInputEmpresa}
                  selectedKey={filter.empresaId}
                  onChange={(e, o) => _onChangeCombo("empresa", e, o)}
                  onBlur={() => _onBlurCombo("empresa")}
                />
                <br />
                <ComboBox
                  label="Gerencia:"
                  componentRef={refGerencia}
                  placeholder="Seleccione Gerencia"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={gerencia}
                  onInput={_onInputGerencia}
                  selectedKey={filter.gerenciaId}
                  onChange={(e, o) => _onChangeCombo("gerencia", e, o)}
                  onBlur={() => _onBlurCombo("gerencia")}
                />
                <br />
                <ComboBox
                  label="Lugar Movilización:"
                  componentRef={refLugarMovilizacion}
                  placeholder="Ingrese Lugar Movilización"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={lugarMovilizacion}
                  onInput={_onInputLugarMovilizacion}
                  selectedKey={filter.lugarMovilizacionId}
                  onChange={(e, o) => _onChangeCombo("LugarMovilizacion", e, o)}
                  onBlur={() => _onBlurCombo("lugarMovilizacion")}
                />
              </div>
            </div>
          </div>
        </>
      </Panel>

      <Panel
        type={PanelType.medium}
        isOpen={isOpenFilter}
        onDismiss={dismissFilter}
        headerText="Asignar a helicóptero"
        closeButtonAriaLabel="Close"
        // onRenderFooterContent={onRenderFooterFilter}
        isFooterAtBottom={true}
      >
        <div className="ms-Grid" dir="ltr" style={{ paddingTop: "20%" }}>
          <Stack tokens={stackTokens}>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm6 ms-md4 ms-lg6">
                <ComboBox
                  label="Destino"
                  componentRef={refDestino}
                  placeholder="Destino"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={destino}
                  onKeyUp={(e) => _onUpCombo("destino", e)}
                  selectedKey={filter.campamentoId}
                  onChange={(e, o) => _onChangeCombo("destino", e, o)}
                  onBlur={() => _onBlurCombo("destino")}
                  required
                />
              </div>

              <div className="ms-Grid-col ms-sm6 ms-md8 ms-lg6">
                <ComboBox
                  label="Empresa"
                  componentRef={refEmpresa}
                  placeholder="Empresa"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={empresa}
                  onKeyUp={(e) => _onUpCombo("empresa", e)}
                  selectedKey={filter.empresaId}
                  onChange={(e, o) => _onChangeCombo("empresa", e, o)}
                  onBlur={() => _onBlurCombo("empresa")}
                  required
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm6 ms-md8 ms-lg6">
                <ComboBox
                  label="Gerencia"
                  componentRef={refGerencia}
                  placeholder="Gerencia"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={gerencia}
                  onKeyUp={(e) => _onUpCombo("gerencia", e)}
                  selectedKey={filter.gerenciaId}
                  onChange={(e, o) => _onChangeCombo("gerencia", e, o)}
                  onBlur={() => _onBlurCombo("gerencia")}
                  required
                />
              </div>
            </div>
          </Stack>
        </div>
      </Panel>
    </>
  );
};
